// extracted by mini-css-extract-plugin
export default {"form":"OrderForm_form__uktnZ","form-fields":"OrderForm_form-fields__OlY9h"};